// extracted by mini-css-extract-plugin
export default {"showMessage":"ShowMessage_showMessage__l80Hp"};